import AmsRewardsCsvHtml from './ams-rewards.csv.html';

export function AmsRewardsSettingsCtrl (
  $uibModal,
  $q,
  $state,
  $scope,
  $translate,
  ams_autoclubs,
  ams_file_frequency,
  confirm,
  integrations,
  messages,
  workshopAPI
) {
  $scope.integrations  = integrations;
  $scope.ams_autoclubs = ams_autoclubs;
  $scope.ams_frequency = ams_file_frequency;
  $scope.loaded        = true;

  $scope.save = function (form) {
    workshopAPI.patch('/company_integrations', $scope.integrations, 'company_integration').then(function (data) {
      return data.ams_first_setup ? workshopAPI.post('/ams_rewards/send_activation_email_to_ams', data, 'ams_rewards').then(() => {
        return $translate.instant('JS_SPACE.AMS_REWARDS.REQUEST_SENT', { name: 'AMS Rewards' });
      }) : $q.when($translate.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'));
    }).then(message => {
      messages.show(message, 'success');

      $state.reload();
    }).catch(data => {
      messages.error(data);
    });
  };

  $scope.activate = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', { name: 'AMS Rewards' })).then(() => {
      return workshopAPI.get('/company_integration/add_ams_rewards');
    }).then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', { name: 'AMS Rewards' }), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.remove = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.REMOVE', { name: 'AMS Rewards' })).then(() => {
      return workshopAPI.get('/company_integration/remove_ams_rewards')
    }).then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.REMOVED', { name: 'AMS Rewards' }), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.downloadCsv = function () {
    $uibModal.open({
      templateUrl: AmsRewardsCsvHtml,
      controller: 'AmsRewardsCsvCtrl',
      resolve: {
        integrations () {
          return $scope.integrations;
        }
      }
    }).result
  };
}
